
import { defineComponent } from 'vue'

export default defineComponent({
	name: 'Modal',
	props: {
		gameState: String
	},
	computed: {
		visible: function() {
			if (this.gameState === 'level-select') return true
			if (this.gameState === 'finish') return true
			if (this.gameState === 'giveup') return true
			return false
		}
	},
})
